export const ROUTE_EVENTS_ROOT = '/city_events';


// WEBPACK FOOTER //
// ./src/components/CityEvents/constants.ts